var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSystemSpecs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.581,
    height: 53.581,
    viewBox: "0 0 53.581 53.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-speedometer",
    "data-name": "Icon ionic-md-speedometer",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_641",
    "data-name": "\\uD328\\uC2A4 641",
    d: "M9,29.25H41.973v6.182H9Z",
    transform: "translate(4.679 21.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_642",
    "data-name": "\\uD328\\uC2A4 642",
    d: "M22.65,26.771a4.122,4.122,0,1,0-1.133-8.089L12.925,12.41l-.515.451,6.3,8.591a4.021,4.021,0,0,0-.18,1.2A4.117,4.117,0,0,0,22.65,26.771Z",
    transform: "translate(7.516 7.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_643",
    "data-name": "\\uD328\\uC2A4 643",
    d: "M30.166,3.375A26.784,26.784,0,0,0,9.055,46.652h7.574l.515-.515L19.99,43.29l-2.95-2.95-2.847,2.834A20.53,20.53,0,0,1,9.66,32.226h4.019V28.1H9.66a20.53,20.53,0,0,1,4.534-10.948l2.847,2.834,2.95-2.95-2.834-2.847A20.53,20.53,0,0,1,28.1,9.66v4.019h4.122V9.66a20.53,20.53,0,0,1,10.948,4.534l-2.834,2.847,2.95,2.95,2.847-2.834A20.53,20.53,0,0,1,50.671,28.1H46.652v4.122h4.019a20.53,20.53,0,0,1-4.534,10.948L43.29,40.341l-2.95,2.95,2.847,2.847.515.515h7.574A26.784,26.784,0,0,0,30.166,3.375Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemSpecs);
export default __webpack_public_path__ + "static/media/system_specs.9dd326a533d0659142cadf9a58a5a0d3.svg";
export { ForwardRef as ReactComponent };